<template>
  <div class="application-denied-wrapper">
    <main class="application-denied-container">
      <section class="application-denied-explanation">
        <img
          class="parcelex-logo"
          src="https://cdn.parcelex.com.br/assets/v3/logos/parcelex-white.png"
          alt="Logo da Parcelex"
        >

        <h1 class="title">No momento não temos crédito disponível para você</h1>

        <p class="explanation">
          Ainda não temos crédito disponível para o seu perfil. Caso tenha dúvidas,
          saiba mais sobre os critérios de avaliação <a class="help-link" target="_blank" href="https://ajuda.parcelex.com.br/credito-indisponivel">neste link</a>.
        </p>

        <p class="next-application-try">
          Você poderá aplicar novamente a partir de {{ nextApplyDay }}
        </p>
      </section>

      <aside class="offers">
          <button class="scroll-down-button hide-on-large" @click="scrollToOffers">
          <ChevronDownIcon color="#0F172A" />
        </button>

        <section class="partner-offers">
          <h2 class="title">Confira essas ofertas</h2>
          <a
            class="offer will"
            target="_blank"
            href="https://will.onelink.me/3u0P?af_xp=custom&pid=parcelex&c=Campanha_Parcelex&af_dp=will%3A%2F%2F&af_siteid=tela_neg"
            @click="handleSendEventLog({
              action: 'clicou-em-cartao-de-credito-will-bank',
            })"
          >
            <div class="offer-info">
              <img
                class="offer-img"
                src="https://cdn.parcelex.com.br/assets/v3/logos/willbank.svg"
                alt="Logo do Will Bank"
              >

              <div class="will">
                <span class="offer-description">Cartão de crédito digital</span>
                <span class="offer-owner">Will Bank</span>
              </div>
            </div>

            <ChevronRightIcon size="16" color="#FFFFFF" />
          </a>
          <a
            class="offer jeitto"
            target="_blank"
            href="https://www.jeitto.com.br/?utm_source=parceiro&utm_medium=parcelex&utm_campaign=negados"
            @click="handleSendEventLog({
              action: 'clicou-em-credito-jeitto',
            })"
          >
            <div class="offer-info">
              <img
                class="offer-img"
                src="https://cdn.parcelex.com.br/assets/v3/logos/logo-jeitto-48.svg"
                alt="Logo da Jeitto"
              >

              <div>
                <span class="offer-description">Precisando de crédito?</span>
                <span class="offer-owner">Jeitto</span>
              </div>
            </div>

            <ChevronRightIcon size="16" color="#FFFFFF" />
          </a>
          <a
            class="offer bv"
            target="_blank"
            href="https://onelink.to/parcelexfgts1"
            @click="handleSendEventLog({
              action: 'clicou-em-emprestimo-fgts-bv',
            })"
          >
            <div class="offer-info">
              <img
                class="offer-img"
                src="https://cdn.parcelex.com.br/assets/v3/logos/logo-bv.svg"
                alt="Logo do Banco BV"
              >

              <div>
                <span class="offer-description">Empréstimo FGTS</span>
                <span class="offer-owner">Banco BV</span>
              </div>
            </div>

            <ChevronRightIcon size="16" color="#FFFFFF" />
          </a>
        </section>

      </aside>
    </main>
  </div>
</template>

<script>
import { ChevronRightIcon } from '@vue-hero-icons/outline';
import { ChevronDownIcon } from '@vue-hero-icons/solid';

import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import ParcelexApi from '../../../services/parcelex';

export default {
  name: 'application-denied',
  data: () => ({
    retailers: [
      {
        name: 'Zoom',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-zoom-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-zoom@2x-v2.png',
        altIcon: 'Logo do Zoom',
        redirectLink: 'https://www.zoom.com.br?og=19352&utm_source=Parcelex&utm_medium=parceiro',
      },
      {
        name: 'Buscapé',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-buscape-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-buscape@2x-v2.png',
        altIcon: 'Logo do Buscapé',
        redirectLink: 'https://www.buscape.com.br',
      },
      {
        name: 'Hotmart',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-hotmart-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-hotmart@2x-v2.png',
        altIcon: 'Logo da Hotmart',
        redirectLink: 'https://hotmart.com/pt-br',
      },
      {
        name: 'Vivo Shopping',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-vivo-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-vivo@2x-v2.png',
        altIcon: 'Logo da Vivo Shopping',
        redirectLink: 'https://loja.vivo.com.br/',
      },
      {
        name: 'Novo Mundo.com',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-novo-mundo-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-novo-mundo@2x-v2.png',
        altIcon: 'Logo da Novo Mundo',
        redirectLink: 'https://www.novomundo.com.br',
      },
      {
        name: 'Soft by Everest',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-soft-by-everest-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-soft-by-everest@2x-v2.png',
        altIcon: 'Logo da Soft by Everest',
        redirectLink: 'https://www.softpurificadores.com.br/',
      },
      {
        name: 'Loja da Massa',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-loja-da-massa-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-loja-da-massa@2x-v2.png',
        altIcon: 'Logo da Loja da Massa',
        redirectLink: 'https://www.lojadamassa.com',
      },
      {
        name: 'Tupperware',
        iconUrl: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-tupperware-v2.png',
        iconUrl2x: 'https://cdn.parcelex.com.br/assets/v3/logos/logo-tupperware@2x-v2.png',
        altIcon: 'Logo da Tupperware',
        redirectLink: 'https://www.tupperware.com.br',
      },
    ],
    lastPage: 0,
    currentPage: 0,
    maxRetailerPerPage: 4,
  }),
  computed: {
    ...mapState('tracking', ['trackId']),
    nextApplyDay() {
      return moment().add(60, 'days').format('DD/MM/YYYY');
    },
    retailersInPagination() {
      return this.retailers.reduce((acc, curr, index) => {
        const pageIndex = Math.floor(index / this.maxRetailerPerPage);
        if (!acc[pageIndex]) {
          acc[pageIndex] = {
            retailers: [],
          };
        }

        acc[pageIndex].retailers.push(curr);

        return acc;
      }, []);
    },
  },
  methods: {
    ...mapActions('login', ['sendEvent', 'sendEventLog']),
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleRetailerWrapperClick(evt) {
      const isPageChanged = this.lastPage !== this.currentPage;
      if (!isPageChanged) return;

      this.lastPage = this.currentPage;
      if (['retailer', 'retailer-img'].includes(evt.target.className) && isPageChanged) {
        evt.preventDefault();
      }
    },
    handleSendEventLog({ action }) {
      this.sendEventLog({
        action,
        origin: window.location.href.split('?')[0],
      });
    },
    scrollToOffers() {
      const scrollDiv = document.querySelector('.offers').offsetTop;
      window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
    },
    async sendEvent({ action, data }) {
      ParcelexApi.post('public/event/send', {
        action,
        source: 'login',
        origin: window.location.href.split('?')[0],
        data,
      }).catch((e) => console.error(e));
    },
  },
  async mounted() {
    if (this.trackId) {
      this.sendEvent({
        action: 'visualizou',
        data: {
          trackId: this.trackId,
          ctaSignInShowed: true,
          groupCode: this.createAccountGroupCode,
          userTestId: this.createAccountTrackTestId,
        },
      }).then((e) => console.warn(e));
    }
  },
  components: {
    ChevronDownIcon,
    ChevronRightIcon,
  },
};
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }

  // font-family: 'Arboria';
  @import url("https://use.typekit.net/ioq1obq.css");
  // font-family: 'Usual';
  @import url("https://use.typekit.net/vtp2byb.css");

  .application-denied-wrapper {
    background: url('https://cdn.parcelex.com.br/assets/v3/abstract/pattern.png'), #278DB3;
    background-size: cover;
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position: bottom right;
    overflow: hidden;
    min-height: 100vh;

    display: flex;
    justify-content: center;
    margin: 0 auto;
    align-items: center;
  }

  .application-denied-container {
    display: flex;
    justify-content: space-between;

    max-width: 960px;
    width: 100%;
  }

  .application-denied-explanation {
    width: 384px;

    .parcelex-logo {
      margin-top: 0px;
      height: 32px;
    }

    .title {
      font-family: 'Arboria';
      font-weight: 700;
      font-size: 28px;
      line-height: 32px;

      color: #FFFFFF;

      margin-top: 36px;
    }

    .explanation {
      font-family: 'Usual';
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;

      color: #FFFFFF;

      margin-top: 20px;
    }

    .help-link {
      color: #FFFFFF;
    }

    .next-application-try {
      font-family: 'Usual';
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;

      color: #FFFFFF;

      margin-top: 20px;
    }
  }

  .scroll-down-button {
    position: absolute;
    top: -16px;
    left:0;
    right:0;
    margin-left: auto;
    margin-right: auto;

    width: 32px;
    height: 32px;

    border: 0;
    border-radius: 18px;

    background-color: #FFFFFf;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);

    &:hover {
      background-color: #FFFFFF;
      border: 0;
      box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
    }
  }

  .partner-offers {
    padding: 36px 36px 36px 36px;
  }

  .retailer-offers {
    padding-bottom: 36px;
  }

  .offers {
    position: relative;
    background-color: #FFFFFF;
    border-radius: 24px;
    box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14);
    width: 448px;
    padding: 0px;
    height: max-content;

    .title {
      font-family: 'Usual';
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;

      color: #0F172A;
    }

    .offer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      padding: 12px 16px;
      border-radius: 12px;
      color: #FFFFFF;
      text-decoration: none;

      &.finanZero {
        background-color: #00A69F;
        margin-top: 20px;
      }

      &.bv {
        background-color: #5775D0;
        margin-top: 16px;
      }

      &.jeitto {
        background-color: #F58220;
        margin-top: 16px;
      }

      &.bpc {
        background-color: #101ABF;
        margin-top: 16px;
      }

      &.will {
        background-color: #FFD900;
        margin-top: 16px;
      }

      .offer-info {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .offer-img {
        width: 48px;
        height: 48px;
      }

      .offer-description {
        font-family: 'Usual';
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        display: block;
      }

      .offer-owner {
        font-family: 'Usual';
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .will {
      color: #000000
    }

    .divisor {
      display: flex;
      align-items: center;
      font-family: 'Usual';
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      text-transform: uppercase;
      gap: 8px;

      margin-top: 20px;
      padding: 0 36px;

      color: #64748B;
    }

    .divisor::before,
    .divisor::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #E2E8F0;
    }

    .subtitle {
      font-family: 'Usual';
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      padding: 0 36px;

      margin-top: 20px;
      color: #0F172A;
    }

    .retailer-carousel {
      margin-top: 20px;
      padding: 0 30px;

      ::v-deep {
        .VueCarousel-slide {
          padding: 0 6px;
        }

        .VueCarousel-pagination {
          margin-top: 12px;
        }

        .VueCarousel-dot-container {
          margin-top: 0 !important;
          display: flex;
          justify-content: center;
          gap: 8px;

          .VueCarousel-dot {
            margin-top: 0 !important;

            &:focus {
              outline: none;
            }
          }
        }
      }
    }

    .retailers-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      .retailer {
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 8px;
        height: 64px;

        border: 1px solid #E2E8F0;
        border-radius: 12px;
        text-decoration: none;

        &:hover {
          border: 1px solid #36A3CA;
          cursor: pointer;
        }

        &.disabled {
          pointer-events: none;
        }
      }

      .retailer-img {
        width: 48px;
        height: 48px;
        border-radius: 8px;
      }

      .retailer-name {
        font-family: 'Usual';
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;

        color: #0F172A;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @media (max-width: $lg) {
    .application-denied-wrapper {
      background: none;
      min-height: auto;
    }

    .application-denied-container {
      flex-direction: column;
      width: 100%;
      gap: 0;
      max-width: 100%;
    }

    .application-denied-explanation {
      background: url('https://cdn.parcelex.com.br/assets/v3/abstract/pattern.png'), #278DB3;
      background-size: auto;
      background-repeat: repeat;
      background-blend-mode: multiply;
      background-position: bottom right;
      overflow: hidden;

      padding: 24px 24px 36px 24px;
      width: 100%;

      .parcelex-logo {
        margin-top: 0;
      }

      .title {
        font-size: 24px;
        margin-top: 24px;
      }

      .explanation {
        margin-top: 12px;
      }

      .next-application-try {
        line-height: 20px;
        margin-top: 12px;
      }
    }

    .partner-offers {
      padding: 36px 24px 0 24px;
    }

    .offers {
      border-radius: 0;
      width: 100%;

      .divisor, .subtitle {
        padding: 0 24px;
      }

      .retailer-carousel {
        padding: 0 18px;
      }
    }
  }
</style>
